/** Every custom-field type the product supports. */
export const FIELD_TYPES = {
  address: "address",
  checkbox: "checkbox",
  date: "date",
  // The API enum is additive-only, so this value stays registered. It is not
  // a type a field is created with: a date that carries its time is `date`
  // with the `includeTime` config, and the server canonicalizes an incoming
  // `dateTime` to that on write. `dateKindOf` reads a row that still wears
  // it as the instant kind.
  dateTime: "dateTime",
  select: "select",
  email: "email",
  files: "files",
  // A computed value: the field carries an expression over the entity's other
  // fields and the server derives the value. Nothing writes it. The type is
  // registered so the schema, the pickers and the type tables know the name;
  // the expression editor and the evaluator are not built yet, so every
  // create surface offers it disabled.
  formula: "formula",
  // The multi-cardinality twin of `select` — "Multi Select" in the UI.
  // Cardinality is the type: select picks one option, labels picks many.
  labels: "labels",
  member: "member",
  money: "money",
  number: "number",
  paragraph: "paragraph",
  phone: "phone",
  photos: "photos",
  region: "region",
  text: "text",
  time: "time",
  url: "url",
} as const;

export type FieldType = keyof typeof FIELD_TYPES;
